export class TempoApontamento {
  public inicio: number;
  public termino: number;
}
